import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';

const WhatsappIcon = () => {
  return (
    <div>
      <a
        href="https://wa.me/+919898042339"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 bg-green-500 text-white rounded-full p-3 shadow-lg hover:bg-green-600 transition border border-white"
        style={{ background: 'green' }}
      >
        <FaWhatsapp size={28} color="white" />{' '}
        {/* icon color white for visibility on green background */}
      </a>
    </div>
  );
};

export default WhatsappIcon;
